import React, { FC } from 'react';

import { Count } from './styled';

export const LengthCounter: FC<LengthCounterProps> = ({ value, maxLength, ...props }) => {
  if (!value) return null;

  return (
    <Count {...props}>
      {value.length} из {maxLength} символов
    </Count>
  );
};

export interface LengthCounterProps {
  value?: string;
  maxLength: number;
}
